var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-flex",
    [
      _c(
        "h3",
        { staticClass: "headline" },
        [_c("v-list-item-title", [_vm._v("Filtro ordini")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      filled: "",
                      "full-width": "",
                      label: "Numero ordine",
                    },
                    model: {
                      value: _vm.filtroNumOrdine,
                      callback: function ($$v) {
                        _vm.filtroNumOrdine = $$v
                      },
                      expression: "filtroNumOrdine",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      filled: "",
                      "full-width": "",
                      label: "Codice LAK",
                    },
                    model: {
                      value: _vm.filtroCodLAK,
                      callback: function ($$v) {
                        _vm.filtroCodLAK = $$v
                      },
                      expression: "filtroCodLAK",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-text-field", {
                    attrs: { filled: "", "full-width": "", label: "Lotto" },
                    model: {
                      value: _vm.filtroLotto,
                      callback: function ($$v) {
                        _vm.filtroLotto = $$v
                      },
                      expression: "filtroLotto",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-switch", {
                    attrs: { label: "Solo ordini USA" },
                    model: {
                      value: _vm.soloUSA,
                      callback: function ($$v) {
                        _vm.soloUSA = $$v
                      },
                      expression: "soloUSA",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-switch", {
                    attrs: { label: "Solo lavorazioni con note" },
                    model: {
                      value: _vm.soloConNote,
                      callback: function ($$v) {
                        _vm.soloConNote = $$v
                      },
                      expression: "soloConNote",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      filled: "",
                      items: _vm.opzioniCampionarioProduzione,
                      "item-text": "label",
                      "item-value": "value",
                    },
                    model: {
                      value: _vm.campionarioProduzione,
                      callback: function ($$v) {
                        _vm.campionarioProduzione = $$v
                      },
                      expression: "campionarioProduzione",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "full-width": "",
                      filled: "",
                      "small-chips": "",
                      "deletable-chips": "",
                      multiple: "",
                      label: "Filtro per stagioni",
                      items: _vm.stagioniFiltrate,
                      "search-input": _vm.searchStagione,
                      "item-text": "id",
                      "item-value": "id",
                    },
                    on: {
                      "update:searchInput": function ($event) {
                        _vm.searchStagione = $event
                      },
                      "update:search-input": function ($event) {
                        _vm.searchStagione = $event
                      },
                    },
                    model: {
                      value: _vm.filtroStagioni,
                      callback: function ($$v) {
                        _vm.filtroStagioni = $$v
                      },
                      expression: "filtroStagioni",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "full-width": "",
                      filled: "",
                      "small-chips": "",
                      "deletable-chips": "",
                      multiple: "",
                      label: "Filtro per modelli",
                      items: _vm.modelliFiltrati,
                      "search-input": _vm.searchModello,
                      "item-text": "desc",
                      "item-value": "id",
                    },
                    on: {
                      "update:searchInput": function ($event) {
                        _vm.searchModello = $event
                      },
                      "update:search-input": function ($event) {
                        _vm.searchModello = $event
                      },
                    },
                    model: {
                      value: _vm.filtroModelli,
                      callback: function ($$v) {
                        _vm.filtroModelli = $$v
                      },
                      expression: "filtroModelli",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "full-width": "",
                      filled: "",
                      "small-chips": "",
                      "deletable-chips": "",
                      multiple: "",
                      label: "Filtro per fasi",
                      items: _vm.fasiFiltrate,
                      "search-input": _vm.searchFase,
                      "item-text": "desc",
                      "item-value": "id",
                    },
                    on: {
                      "update:searchInput": function ($event) {
                        _vm.searchFase = $event
                      },
                      "update:search-input": function ($event) {
                        _vm.searchFase = $event
                      },
                    },
                    model: {
                      value: _vm.filtroFasi,
                      callback: function ($$v) {
                        _vm.filtroFasi = $$v
                      },
                      expression: "filtroFasi",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "full-width": "",
                      filled: "",
                      "small-chips": "",
                      "deletable-chips": "",
                      multiple: "",
                      label: "Filtro per consegne",
                      items: _vm.consegneFiltrate,
                      "search-input": _vm.searchConsegna,
                      "item-text": "desc",
                      "item-value": "id",
                    },
                    on: {
                      "update:searchInput": function ($event) {
                        _vm.searchConsegna = $event
                      },
                      "update:search-input": function ($event) {
                        _vm.searchConsegna = $event
                      },
                    },
                    model: {
                      value: _vm.filtroConsegne,
                      callback: function ($$v) {
                        _vm.filtroConsegne = $$v
                      },
                      expression: "filtroConsegne",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                { attrs: { text: "" }, on: { click: _vm.svuotaFiltro } },
                [_vm._v("Svuota")]
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: { click: _vm.annullaModificaFiltro },
                },
                [_vm._v("Annulla")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "primary" },
                  on: { click: _vm.applicaModificaFiltro },
                },
                [_vm._v("Applica")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }